import React, { useContext } from 'react';
import ModalContext from '../Modal/ModalContext';
import ConfirmForm from './ConfirmForm';

// Use this component as the base for a modal confirm
// form so that the modal's buttons have access to submit the form.
function ModalConfirmForm(props) {
  const {
    setSubmitFn,
    setSubmitDisabled,
  } = useContext(ModalContext);

  return (
    <ConfirmForm
      {...props}
      setOuterSubmitFn={setSubmitFn}
      setOuterSubmitDisabled={setSubmitDisabled}
    />
  );
}

export default ModalConfirmForm;
